import React, { useEffect } from "react";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { BrowserView, isBrowser } from "react-device-detect";
import thunk from "redux-thunk";

import FeaturedPacks from "components/FeaturedPacks";
import XferAudioPlayer from "components/XferAudioPlayer";
import PresetTable from "components/PresetTable";

// Import Redux actions and reducers
import rootReducer from "reducers";
import { fetchAllPacks, fetchAllCartItems } from "actions/index";

// Create a store for the preset packs page
const store = createStore(rootReducer, applyMiddleware(thunk));

// Main component for preset packs page
const Main = () => {
  useEffect(() => {
    // Fetch data on component mount
    store.dispatch(fetchAllPacks());
    store.dispatch(fetchAllCartItems());
    
    // Set up event listener for cart updates
    const handleCartUpdate = () => {
      console.log("Main component: Cart updated, refreshing cart data");
      store.dispatch(fetchAllCartItems());
    };
    
    // Add event listener for cart updates
    window.addEventListener('cart-updated', handleCartUpdate);
    
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('cart-updated', handleCartUpdate);
    };
  }, []);

  return (
    <Provider store={store}>
      <div className="preset-pack-container">
        <h1 className="mt-5 mb-4">Serum Preset Packs</h1>
        <FeaturedPacks />
        <h2 className="mt-5 mb-4">All Preset Packs</h2>
        <PresetTable />
        <XferAudioPlayer />
      </div>
    </Provider>
  );
};

export default Main;
